import $http from '$http'
import { util, lg } from 'utils';

export default {
    methods: {
        addAgent(data) {
            $http.post('api/Agent/AddAgentEx', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加意向客户成功！',
                        type: 'success'
                    });
                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        updateAgent(data) {
            $http.post('api/Agent/UpdateCustomerEx', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '已成功修改！',
                        type: 'success'
                    });
                    this.$emit('reload-list');
                    this.close();
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/edit-dialog/services.js